import { createFetcher } from '../../Fetcher/Fetcher'
import {
  getBaseUrl,
  QUIZ_ENDPOINT,
  ADMIN_ENDPOINT,
  LIVE_CANDIDATES_ENDPOINT,
} from '../../constant'
import { unixTimeStamp } from '../../utils'

export class LiveCandidates {
  static getInstance() {
    if (!this.instance) {
      this.instance = new LiveCandidates(QUIZ_ENDPOINT, createFetcher())
    }
    return this.instance
  }

  constructor(endPoint, fetcherObj) {
    this.endPoint = endPoint
    this.fetcher = fetcherObj
  }

  async getAllLiveCandidates(reqId) {
    const url = `${
      getBaseUrl() + ADMIN_ENDPOINT + this.endPoint
    }/${reqId}${LIVE_CANDIDATES_ENDPOINT}`

    const response = await this.fetcher.getData(url)
    const candidatesList = Array.isArray(response?.data?.data)
      ? response.data.data
      : []

    if (response.status === 200) {
      candidatesList.forEach((candidate, index) => {
        candidatesList[index] = {
          ...candidate,
          quizStartTime: new Date(unixTimeStamp(candidate?.quizStartTime)),
          quizEndTime: new Date(unixTimeStamp(candidate?.quizEndTime)),
        }
      })
      return candidatesList
    }

    return response
  }

  async getAllSortandFilterLiveCandidates(
    reqId,
    limit,
    offset,
    sortBy,
    filterStatus
  ) {
    const url = `${
      getBaseUrl() + ADMIN_ENDPOINT + this.endPoint
    }/${reqId}${LIVE_CANDIDATES_ENDPOINT}${
      filterStatus ? `?status=${filterStatus}` : ''
    }${filterStatus ? `&limit=${limit}` : `?limit=${limit}`}&offset=${offset}${
      sortBy ? `&sortBy=${sortBy}` : ''
    }`

    return this.fetcher.getData(url)
  }

  async getMyViewCandidates(
    reqId,
    limit,
    offset,
    filterStatus,
    sortBy,
    userInputArray
  ) {
    const url = `${
      getBaseUrl() + ADMIN_ENDPOINT + this.endPoint
    }/${reqId}${LIVE_CANDIDATES_ENDPOINT}${
      filterStatus ? `?status=${filterStatus}` : ''
    }${
      filterStatus ? `&email=${userInputArray}` : `?email=${userInputArray}`
    }&limit=${limit}&offset=${offset}${sortBy ? `&sortBy=${sortBy}` : ''}`

    return this.fetcher.getData(url)
  }
}

export const createLiveCandidates = () => LiveCandidates.getInstance()
